import utagLinkGeneric from './utagLinkGeneric';

function utagLinkHeader (eventCategory = 'Nav-Top') {

	return ({ eventAction, eventLabel = '' }) => {

		utagLinkGeneric({
			eventCategory,
			eventAction,
			eventLabel
		});

	};

}

export default utagLinkHeader;
